// LIB
import React, { useState } from 'react';
import styled from 'styled-components';
import { auth, provider, isFirebaseInitialized } from '../../firebase'; // Assurez-vous que le chemin est correct
import { signInWithPopup } from 'firebase/auth';
import { colors, fontFamily, fontSize } from '../../Design_System/DesignSystem';
import { Text } from '../atoms/Text';

interface PasswordProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
}

const Password = ({ setSelectedItem }: PasswordProps) => {
  const [errorMessage, setErrorMessage] = useState('');

  const handleGoogleSignIn = async () => {
    if (!isFirebaseInitialized()) {
      setErrorMessage(
        'Firebase is not configured. Please check your environment variables.'
      );
      return;
    }
    try {
      const result = await signInWithPopup(auth!, provider!);
      const user = result.user;

      // Vérifiez si l'email correspond à l'email autorisé
      if (
        user.email === 'tristan.lemire.sio@gmail.com' ||
        user.email === 'titoulemire77@gmail.com'
      ) {
        localStorage.setItem(
          'a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c',
          user.email
        );
        setSelectedItem(7);
      } else {
        setErrorMessage('Accès refusé : email non autorisé.');
      }
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage('Erreur de connexion : ' + error.message);
      } else {
        setErrorMessage('Erreur de connexion inconnue.');
      }
    }
  };

  return (
    <HomeContainer>
      <Conainer>
        <GoogleButton type="button" onClick={handleGoogleSignIn}>
          <img
            src="https://img.icons8.com/?size=512&id=17949&format=png"
            alt="Google Logo"
          />
          Connexion avec Google
        </GoogleButton>
        {errorMessage && (
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify={false}
            bold={false}
          >
            {errorMessage}
          </Text>
        )}
      </Conainer>
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;

const Conainer = styled.div`
  max-width: 300px;
  margin: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: end;
`;

const GoogleButton = styled.button`
  margin-top: 10px;
  margin-right: 5px;
  border: none;
  border-radius: 8px; /* Bordure arrondie */
  background-color: #4285f4; /* Couleur de fond du bouton Google */
  color: white; /* Couleur du texte */
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 12px 20px; /* Espacement interne */
  font-size: 16px; /* Taille du texte */
  font-weight: bold; /* Mettre le texte en gras */
  transition:
    background-color 0.3s,
    box-shadow 0.3s; /* Effet de transition */

  margin-bottom: 10px;

  img {
    width: 24px; /* Ajustez la taille selon vos besoins */
    height: 24px; /* Ajustez la taille selon vos besoins */
    margin-right: 10px; /* Espacement entre l'icône et le texte */
  }

  &:hover {
    background-color: #357ae8; /* Couleur de fond au survol */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* Ombre au survol */
  }

  &:active {
    background-color: #3367d6; /* Couleur de fond lors du clic */
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2); /* Ombre intérieure lors du clic */
  }
`;

export default Password;
